import { render, staticRenderFns } from "./NaverShoppingTooltip.vue?vue&type=template&id=8031f9a8&"
import script from "./NaverShoppingTooltip.vue?vue&type=script&lang=ts&"
export * from "./NaverShoppingTooltip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports